<template>
  <contact-form-fieldset :legend="labelText">
    <v-select
      ref="citySelect"
      :placeholder="placeholderText"
      :model-value="selected"
      :options="cities"
      :filterable="false"
      :clearable="clearable"
      :select-on-tab="selectOnTab"
      :dropdown-should-open="checkShouldOpenDropdown"
      :filter-by="filterBy"
      :loading="isLoading"
      @update:model-value="setValue"
      @close="close"
      @search="debouncedOnSearch"
      @keypress.enter.prevent=""
    >
      <template #no-options>
        <div v-text="texts.noOptions" />
      </template>
    </v-select>
  </contact-form-fieldset>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import vSelect from 'vue-select';
import debounce from 'lodash-es/debounce';
import { useCitySelect } from 'Main/composables/useCitySelect';
import ContactFormFieldset from './ContactFormFieldset.vue';

export default {
  name: 'CitySelect',

  components: {
    ContactFormFieldset,
    vSelect,
  },

  setup() {
    const { selected, setSelected, dropdownShouldOpen, filterBy } =
      useCitySelect();
    return { selected, setSelected, dropdownShouldOpen, filterBy };
  },

  props: {
    default: {
      default: null,
      type: Object,
    },
    placeholder: {
      default: '',
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    resetOnSelect: {
      default: false,
      type: Boolean,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    selectOnTab: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      texts: theme_vars.cityCaseTypeSelect,
    };
  },

  computed: {
    ...mapState('cities', ['cities', 'isLoading', 'hasLoadedCities']),

    placeholderText() {
      if (this.isLoading) {
        return '';
      }

      if (this.placeholder !== '') {
        return this.placeholder;
      }

      const { writeYourLocationHereHelp } = this.texts;

      return this.required
        ? writeYourLocationHereHelp + ' *'
        : writeYourLocationHereHelp;
    },

    labelText() {
      return this.required
        ? this.texts.writeYourLocationLabel + '*'
        : this.texts.writeYourLocationLabel;
    },
  },

  watch: {
    default: {
      deep: true,
      immediate: true,
      handler() {
        this.selected = this.default;
      },
    },
  },

  methods: {
    ...mapMutations('cities', ['setCities', 'setHasLoadedCities']),

    checkShouldOpenDropdown(VueSelect) {
      return this.hasLoadedCities && this.dropdownShouldOpen(VueSelect);
    },

    debouncedOnSearch: debounce(function (searchText) {
      this.searchCities(searchText.trim());
    }, 300),

    setValue(value) {
      if (this.resetOnSelect) {
        this.selected = null;
        this.setHasLoadedCities(false);
        this.setCities([]);
      }

      this.$emit('on-select', value);
    },

    searchCities(searchText) {
      if (this.isLoading || !searchText || searchText.length < 2) {
        this.setHasLoadedCities(false);
        this.setCities([]);
        return;
      }

      this.$store.dispatch('cities/getCities', { search: searchText });
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>
